// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2619":"9f7fadca","3204":"fa9aa6e4","4225":"9f7fadca","4595":"fa9aa6e4","6395":"ef6616f0","6860":"03f8a770","7406":"ab728270","7999":"f06d8f54","8146":"8d397d2b"}[chunkId] + ".chunk.css";
};